import React from 'react'
import { withRouter } from 'react-router-dom'
import { Form } from 'informed'
import { toast } from 'react-toastify'
import { get, debounce } from 'lodash'
import axios from 'axios'
import Loading from '../../components/Loading'
import BaseCreate from '../../base/BaseCreate'
import { API_HOST } from '../../consts'
import { default as FormContainer } from '../../containers/Form'
import InputSummernote from '../../components/inputs/InputSummernote'

class RevisaoAvaliacao extends BaseCreate {
  api = `${API_HOST}/avaliacoes/avaliacao`;
  fields = ['nome', 'nome_docente', 'valor', 'exame', 'instrucoes', 'numero_de_alternativas', 'area_conhecimento',
    'componente_curricular', 'tipo_aplicacao', 'habilidade', 'candidato_anexo_reposta', 'publico','revisao_item',];
  multiFields = ['tipos_item', 'curso'];

  state = {
    fetchingData: true,
    fields: this.fields,
  }

  validateInstrumento = (goto, next) => {
    const { match, history } = this.props

    this.next = next;
    this.formApi.submitForm();

    if (goto === 'dados') {
      history.push(goto)
      return
    }

    return axios
      .post(`${API_HOST}/avaliacoes/avaliacao/${match.params.id}/validate`)
      .then((response) => {
        history.push(goto)
      })
      .catch((error) => {
        const status = get(error, 'response.status')

        if (status === 400) {
          const msg = get(error, 'response.data.non_field_errors.0')
          if (msg) {
            toast.error(msg)
            return
          }
        }
      })
  }

  render() {
    const { fetchingData, submitting, } = this.state;

    const finaliar = () => {
      const { history } = this.props;
      history.push('/instrumentos-cognitivos');
    }

    return (
      <FormContainer
        title="Confirmar"
        previous="itens"
        last="/instrumentos-cognitivos"
        // onClick={this.handleNext}
        onClick={(goto) => this.validateInstrumento(goto)}
      >
        <Form
          onChange={formState => this.setState({ formState })}
          getApi={(formApi) => { this.formApi = formApi }}
          onSubmit={this.handleSubmit}
        >
          <InputSummernote
            col="col-sm-12"
            label="Revisão "
            field="revisao_item"

          />
        </Form>
      </FormContainer>

    )
  }
}

export default withRouter(RevisaoAvaliacao)
